var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCopyright = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#525254",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M10.492 14.3c1.842 0 2.915-1.033 3.508-2.092l-1.54-.752c-.353.689-1.11 1.237-1.968 1.237-1.54 0-2.65-1.186-2.65-2.793s1.11-2.793 2.65-2.793c.858 0 1.615.548 1.969 1.237L14 7.58c-.593-1.072-1.666-2.08-3.508-2.08C7.956 5.5 6 7.273 6 9.9c0 2.614 1.956 4.4 4.492 4.4"
}))));
export default SvgIconCopyright;